<script lang="ts">
	import { Autocomplete, SearchInput } from '$lib/components';
	import { searchFrom, searchFromPlaceId } from '$lib/stores/search.svelte';

	type Props = {
		apiKey: string;
		error?: string | string[];
	};

	let { apiKey, error = undefined }: Props = $props();

	const setValue = (value: string) => {
		searchFrom.current = value;
		error = undefined;
	};

	const setPlaceId = (placeId: string) => {
		searchFromPlaceId.current = placeId;
	};
</script>

<div class="relative">
	<SearchInput {error}>
		<label for="from" class="input-label">Pickup Location</label>
		<Autocomplete
			id="from"
			name="from"
			placeholder="Enter a pickup location"
			value={searchFrom.current}
			placeId={searchFromPlaceId.current}
			focus={!!error}
			{setValue}
			{setPlaceId}
			{apiKey}
		/>
	</SearchInput>
</div>
